enum CustomerIdentifierInputMethod {
  AutoGenerated = 1,
  GuestName = 2,
  TableTentPicker = 3,
  TableTrackerPicker = 4,
  NumericTextField = 5,
  VehicleNameMakeModelColorForm = 6,
  AddressForm = 7,
  PhoneNumberForm = 8,
  EmailForm = 9,
}

export { CustomerIdentifierInputMethod };
